import { ColaboradorDispendioOutro } from './colaborador-dispendio-outros.model';
import { DispendioOutros } from './dispendio-outros.model';
export class DispendioOutroVO {

  dispendioOutro: DispendioOutros;
  colaboradores: ColaboradorDispendioOutro[];
  isPossuiCpf: boolean;
  constructor(init?: Partial<DispendioOutroVO>) {
    Object.assign(this, init);
  }
}
